import { Platform } from 'react-native';
import { isOnline } from '../connectivity/connectivityInfra';
import type { GlobalFeatureFlagsMap } from './domain/globalFeatureFlags';
import {
  fetchGlobalFeatureFlags,
  getCachedGlobalFeatureFlagsForSync,
} from './globalFeatureFlagsService';

export const WEB_ONLINE_WRITES_KEY = 'web_online_writes' as const;

/** Poll de flags en web: más corto que el TTL de 24 h para poder prender el corte sin F5. */
export const WEB_ONLINE_WRITES_FLAG_POLL_MS = 10 * 60 * 1000;

export class OfflineWriteBlockedError extends Error {
  readonly code = 'offline_write_blocked';

  constructor(message = 'Sin conexión') {
    super(message);
    this.name = 'OfflineWriteBlockedError';
  }
}

type E2EWindow = Window & { __VUELTO_E2E_WEB_ONLINE_WRITES__?: boolean };

function e2eForcesWebOnlineWrites(): boolean {
  if (typeof window === 'undefined') return false;
  return (window as E2EWindow).__VUELTO_E2E_WEB_ONLINE_WRITES__ === true;
}

/** Fail-closed: key ausente o fetch fallido = off. No usar `isGlobalFeatureOn`. */
export function isWebOnlineWritesEnabled(
  flags: GlobalFeatureFlagsMap | null | undefined,
): boolean {
  if (e2eForcesWebOnlineWrites()) return true;
  return flags?.web_online_writes === true;
}

export function isWebOnlineWritesActive(
  flags: GlobalFeatureFlagsMap | null | undefined = getCachedGlobalFeatureFlagsForSync(),
): boolean {
  // Web sin OPFS: siempre online-only (sin cola local), con o sin flag remoto.
  return true;
  return Platform.OS === 'web' && isWebOnlineWritesEnabled(flags);
}

export async function resolveWebOnlineWritesActive(): Promise<boolean> {
  if (Platform.OS !== 'web') return false;
  return true;
}

export async function assertWebOnlineWriteAllowed(): Promise<void> {
  if (!(await resolveWebOnlineWritesActive())) return;
  const online = await isOnline().catch(() => false);
  if (!online) {
    throw new OfflineWriteBlockedError();
  }
}
